/* SLIDE 31 */

import React, { useState } from "react";
import SearchBar from "shared/components/SearchBar";

const DailySchedule = () => {
  const [year, setYear] = useState(2025);
  const [month, setMonth] = useState(11);
  const [day, setDay] = useState(23);
  const [selectedLocation, setSelectedLocation] =
    useState("새마을상점(01-002)");

  // Sample schedule data
  const scheduleData = [
    { name: "홍길동", time: "08:00 ~ 17:00" },
    { name: "홍길동", time: "08:00 ~ 17:00" },
    { name: "홍길동", time: "08:00 ~ 17:00" },
    { name: "홍길동", time: "08:00 ~ 17:00" },
    { name: "홍길동", time: "08:00 ~ 17:00" },
    { name: "홍길동", time: "08:00 ~ 17:00" },
  ];

  return (
    <div className="daily-schedule-container">
      <SearchBar />
      <div className="htContent">
        <div className="table-header">
          <select
            className="table-select"
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="새마을상점(01-002)">새마을상점(01-002)</option>
          </select>
        </div>

        <div className="mn-calendar-header table-heade">
          <select
            className="table-select"
            value={year}
            onChange={(e) => setYear(parseInt(e.target.value))}
          >
            <option value="2025">2025</option>
            <option value="2024">2024</option>
          </select>

          <select
            className="table-select"
            value={month}
            onChange={(e) => setMonth(parseInt(e.target.value))}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="day-header">
          <h2>월 {day}</h2>
        </div>

        <div className="schedule-list">
          {scheduleData.map((item, index) => (
            <div key={index} className="schedule-item">
              <div className="person-name">{item.name}</div>
              <div className="schedule-time">{item.time}</div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default DailySchedule;
